import React from 'react';
import { STATUS, CSS_CLASSES } from '../../../constants';

// Soft transparent avatar colors like contact management (for use in ChatList/ChatHeader)
export const getAvatarColor = (nameOrId) => {
  const str = String(nameOrId || '');
  const colors = [
    'bg-blue-500/20 text-blue-700',
    'bg-emerald-500/20 text-emerald-700',
    'bg-purple-500/20 text-purple-700',
    'bg-rose-500/20 text-rose-700',
    'bg-indigo-500/20 text-indigo-700',
    'bg-pink-500/20 text-pink-700',
    'bg-amber-500/20 text-amber-700',
    'bg-teal-500/20 text-teal-700'
  ];
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return colors[Math.abs(hash) % colors.length];
};

const Avatar = ({
  initials = '',
  color = 'bg-emerald-500/20 text-emerald-700',
  status = STATUS.ONLINE,
  size = 'small', // 'small', 'medium', 'large'
  showStatusDot = true
}) => {
  const bgOnly = color.split(' ')[0] || color;
  const textClass = color.split(' ')[1] || 'text-gray-700';

  const getStatusColorClass = (status) => {
    switch (status) {
      case STATUS.ONLINE:
        return 'bg-green-500';
      case STATUS.BUSY:
        return 'bg-red-500';
      case STATUS.AWAY:
        return 'bg-yellow-500';
      case STATUS.OFFLINE:
        return 'bg-gray-500';
      default:
        return 'bg-green-500';
    }
  };

  const getSizeClasses = (size) => {
    switch (size) {
      case 'small':
        return {
          container: CSS_CLASSES.ICON_CONTAINER.SMALL,
          text: 'text-xs'
        };
      case 'medium':
        return {
          container: 'w-10 h-10',
          text: 'text-base'
        };
      case 'large':
        return {
          container: 'w-12 h-12',
          text: 'text-lg'
        };
      default:
        return {
          container: CSS_CLASSES.ICON_CONTAINER.SMALL,
          text: 'text-sm'
        };
    }
  };

  const sizeClasses = getSizeClasses(size);

  return (
    <div className={`relative inline-flex ${sizeClasses.container} ${sizeClasses.text} font-semibold ${textClass} select-none`}>
      <div className={`${sizeClasses.container} rounded-full ${bgOnly}`} />
      {showStatusDot && (
        <span className={`absolute -right-0.5 -bottom-0.5 h-3 w-3 rounded-full border-2 border-white ${getStatusColorClass(status)}`} />
      )}
      <span className="absolute leading-none inset-0 flex items-center justify-center">{initials}</span>
    </div>
  );
};

export default Avatar;
